import { Analytics } from './analytics';

export * from './types';
export * from './lib';

export const analytics = new Analytics();
